<div class="board-column">

  <div class="column-title-block">
    <div class="column-title">{{ column.name }}</div>
    <div class="column-task-counter"><span *ngIf="column.filteredCount !== column.count"
                                           class="filtered-counter">{{ column.filteredCount }}
      / </span><span>{{ column.count }}</span></div>
  </div>

  <!-- <div class="tasks-container" cdkDropList [cdkDropListData]="column" (cdkDropListDropped)="onDropIn($event)"
    *libInView> -->
  <div class="tasks-container" cdkDropList [cdkDropListData]="column" (cdkDropListDropped)="onDropIn($event)"
       (scroll)="onScroll()">
    <div class="card-wrapper" *ngFor="let card of column.projectsList; trackBy: trackEntityById" cdkDrag
         cdkDragData="card" (cdkDragMoved)="onDragMoved($event)" [cdkDragStartDelay]="cdkStartDelayTime">
      <app-kanban-card [card]="card" #kbCard>
        <div class="ellipsis-to-drag" *ngIf="device === 'isMobile' || device === 'isTablet'">
          <mat-icon class="ellipsis-icon" cdkDragHandle (touchmove)="mouseLeave()">more_horiz</mat-icon>
        </div>
      </app-kanban-card>
    </div>
    <div class="show-more-block-loading" *ngIf="columnLoadingSpinner">
      <lib-mini-progress-spinner></lib-mini-progress-spinner>
    </div>
  </div>
</div>
